export default "__VITE_ASSET__Hs4_Mga2__"